export default __webpack_public_path__ + "static/media/Balancing_tube.0fc245dd.svg";